import { render, staticRenderFns } from "./customer-tags.vue?vue&type=template&id=42159223&"
import script from "./customer-tags.vue?vue&type=script&lang=js&"
export * from "./customer-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports